import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../Layout/Theme/ThemeContext";
import ReportService from '../Controller/ReportController';
import ModuleService from "../../Setup/controller/ModuleController/ModuleController";
import Draggable from 'react-draggable';
import InputParameters from './InputModal';
import OutputParameters from './OutputParameters';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import BASE_URL from "../../../config/config";
import CompanySetupController from "../../SuperAdmin/Controller/Client/SACompanyListController";
import axiosInstance from '../../../config/axiosInstance';
import JasperReportService from '../../Dashboard/Controller/JasperReportController';
function ReportView({ show, onClose, ModuleID, ID }) {

    if (!ModuleID) {
        ModuleID = "0";
    }

    let sModuleID = ModuleID;
    const navigate = useNavigate();
    const [reports, setReports] = useState([]);
    const [ModuleList, setModuleList] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [selectedModuleID, setSelectedModuleID] = useState(ModuleID || 0);
    const [inputValues, setInputValues] = useState({});
    const [outputData, setOutputData] = useState([]);
    const [outputParam, setOutputParam] = useState([]);
    const [error, setError] = useState(null);
    const { theme } = useContext(ThemeContext);
    const [showInputModal, setShowInputModal] = useState(false);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false); // State to control PDF modal visibility
    const [reportName, setReportName] = useState("");
    const [imageData, setImageData] = useState(null);
    const [selectedRowModule, setSelectedRowModule] = useState(ModuleID);
    const [selectedReportID, setSelectedReportID] = useState(null);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const [showOutputModal, setShowOutputModal] = useState(false);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    useEffect(() => {
        fetchModules();

        const clientID = localStorage.getItem('CompanyID');

        if (clientID) {
            debugger;
            setInputValues((prevValues) => ({
                ...prevValues,
                ClientID: clientID,
                ...(ID ? { ID: ID } : {})
            }));
        }
    }, [sModuleID, ID]);

    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }

                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);


    const fetchModules = async () => {
        try {
            const redirectCallback = () => navigate('/');
            let data = await ModuleService.GetAllModules(redirectCallback, "en");

            // remove unwanted modules
            data = data.filter(x => x.PK_SearchModule_ID != 11 && x.PK_SearchModule_ID != 12);

            // ✅ If ModuleID > 0, load only that module
            if (ModuleID && Number(ModuleID) > 0) {
                data = data.filter(x =>
                    x.PK_SearchModule_ID.toString() === ModuleID.toString()
                );
            }

            setModuleList(data);

            // ✅ Auto select module only if ModuleID > 0
            if (ModuleID && Number(ModuleID) > 0) {
                handleModuleSelect(ModuleID);
            }

        } catch (err) {
            setError('Failed to load modules');
            console.error(err);
        }
    };

    const fetchReports = async (moduleID) => {
        try {
            const data = await JasperReportService.GetAllJasperReports(moduleID);
            console.log("Fetched reports for module:", moduleID, data);
            setReports(data);
        } catch (err) {
            setError('Failed to load reports');
            console.error(err);
        }
    };

    const handleModuleSelect = async (moduleID) => {
        setSelectedModuleID(moduleID);
        setSelectedRowModule(moduleID);
        sModuleID = moduleID;
        await fetchReports(moduleID);
    };

    const handleReportSelect = async (reportId, moduleID) => {
        try {
            debugger;
            setReportName("");
            const details = await JasperReportService.getReportDetail(reportId);
            setSelectedReport(details);
            setSelectedReportID(reportId);
            setSelectedModuleID(moduleID);
            setReportName(details.report[0].Name);

            const clientID = localStorage.getItem('CompanyID');
            setInputValues(clientID ? { ClientID: clientID } : {});
            if (details.inputParams[0].filter((x) => x.Name !== "ClientID" && x.Name !== "UserID" && (x.Name !== "ID")
            ).length === 0) {
                
                if (ID.length > 0) {
                    await handleExecuteReport(reportId);
                }
                else
                {
                   setShowInputModal(true); 
                }
            } else {
                setShowInputModal(true); // Show the input modal if input parameters exist
            }
        } catch (err) {
            setError('Failed to load report details');
            console.error(err);
        }
    };

    const generatePDF = (reportTitle, additionalInfo, imageData, outputParams, outputData) => {
        const doc = new jsPDF();
        const currentDate = new Date().toLocaleDateString();

        // Header Section with Company Information
        doc.setFontSize(10);
        doc.setLineWidth(0.3);
        doc.rect(10, 10, 190, 30);

        if (additionalInfo) {
            const lines = additionalInfo.split('\n');
            lines.forEach((line, index) => {
                doc.text(line, 14, 16 + (index * 4)); // Company info lines
            });
        }

        if (imageData) {
            doc.addImage(imageData, 'PNG', 150, 16, 40, 20); // Logo placement
        }

        // Title Section
        doc.rect(10, 45, 190, 12);
        doc.setFontSize(12);
        doc.text(reportTitle, doc.internal.pageSize.width / 2, 52, { align: 'center' });

        // Table Section
        doc.rect(10, 60, 190, doc.internal.pageSize.height - 80);
        const headers = outputParams.map((param) => param.DisplayName);

        const data = outputData.map((row) =>
            outputParams.map((param) => {
                const value = row[param.ColumnName] || "";
                if (typeof value === "string" && value.includes("T")) {
                    const date = new Date(value);
                    return isNaN(date) ? value : date.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
                }
                return value;
            })
        );

        const totalPagesExp = "{total_pages_count_string}";

        doc.autoTable({
            startY: 65,
            head: [headers],
            body: data,
            theme: "grid",
            styles: {
                fontSize: 8,
                cellPadding: 2,
                halign: "center",
            },
            headStyles: {
                fillColor: [22, 160, 133],
                textColor: 255,
                fontSize: 9,
                fontStyle: "bold",
            },
            margin: { bottom: 30 },
            didDrawPage: (data) => {
                const pageNumber = doc.internal.getNumberOfPages();
                const footerText = `Page ${pageNumber} of ${totalPagesExp}`;
                doc.setFontSize(8);
                doc.text(`${currentDate}`, 10, doc.internal.pageSize.height - 10);
                doc.text(footerText, doc.internal.pageSize.width - 50, doc.internal.pageSize.height - 10);
            },
        });

        if (typeof doc.putTotalPages === "function") {
            doc.putTotalPages(totalPagesExp);
        }

        const pdfBlob = doc.output("blob");
        const url = URL.createObjectURL(pdfBlob);
        setPdfUrl(url); // Store the URL in state
        setShowPdfModal(true); // Show the PDF modal
    };

    const handleExecuteReport = async (reportId) => {
        try {
            debugger;
            const JasperReport = await JasperReportService.GetJasperReportByID(reportId);
            let url = JasperReport[0].Link;
            setReportLink(url);
            setReportTitle(JasperReport[0].ReportTitle);

            // Replace placeholders {ClientID}, {UserID} dynamically
            const replacedKeys = {};
            Object.keys(inputValues).forEach((key) => {
                const placeholder = new RegExp(`{${key}}`, 'g');
                let value = inputValues[key];

                if (key === "ClientID") {
                    value = localStorage.getItem("CompanyID");
                } else if (key === "UserID") {
                    value = localStorage.getItem("UserID");
                }

                if (url.includes(`{${key}}`)) {
                    url = url.replace(placeholder, value);
                    replacedKeys[key] = true;
                }
            });

            // ✅ Build query object including *all* params
            const queryObj = {
                ...inputValues,
                format: 'pdf',
                ReportName: JasperReport[0].ReportName,
                ReportType: JasperReport[0].ReportType,
                name: JasperReport[0].ReportName,
                ...(ID.length > 0 && { ID: ID })

            };


            const queryString = new URLSearchParams(queryObj).toString();

            // ✅ Call proxy endpoint with query string
            const response = await axiosInstance.get(`/Dashboard/ProxyReport?${queryString}`, {
                responseType: 'blob' // important for PDF
            });

            // ✅ Convert Blob to Object URL
            const pdfObjectUrl = URL.createObjectURL(response.data);

            setPdfUrl(pdfObjectUrl);
            setShowPdfModal(true);
            setShowInputModal(false);
            setShowOutputModal(false);

        } catch (err) {
            console.error('Error executing report:', err);
            setError('Failed to execute the report.');
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handleInputChange = (param, value) => {
        setInputValues((prevValues) => ({ ...prevValues, [param]: value }));
    };
    return (
        <div>
            <div className="modal fade show d-block" tabIndex="-1" data-backdrop="static">
                <div className={`modal-dialog ${Number(ModuleID) > 0 ? '' : 'modal-lg'}`}>
                    <Draggable handle=".modal-header">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title">Reports Selection</h5>
                                <button type="button" className="close" onClick={onClose}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    {(ModuleID.toString() === "0" &&
                                        <div className="col-sm-6">
                                            <table className="table">
                                                <thead>
                                                    <tr><th>Report Category</th></tr>
                                                </thead>
                                                <tbody>
                                                    {ModuleList.map((module) => (
                                                        <tr key={module.PK_SearchModule_ID}
                                                            onClick={() => handleModuleSelect(module.PK_SearchModule_ID)}
                                                            style={{
                                                                backgroundColor: selectedRowModule.toString() === module.PK_SearchModule_ID.toString() ? 'rgb(197, 218, 237)' : '', // Highlight background
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            <td>{module.vc_ModuleName}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                    <div className={`col-sm-${ModuleID.toString() > "0" ? "12" : "6"}`}>
                                        <table className="table">
                                            <thead>
                                                <tr><th>Report File</th></tr>
                                            </thead>
                                            <tbody>
                                                {reports.map((report) => (
                                                    <tr key={report.ID}
                                                        onClick={() => handleReportSelect(report.ID, report.ModuleID)}
                                                        style={{
                                                            backgroundColor: selectedReportID === report.ID ? '#d0ebff' : '', // Highlight background
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        <td>{report.ReportTitle}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-danger" onClick={onClose}>
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>


                            </div>
                        </div>
                    </Draggable>
                </div>
            </div>


            {showInputModal && (
                <InputParameters
                    inputParams={selectedReport.inputParams[0]}
                    inputValues={inputValues}
                    onInputChange={handleInputChange}
                    onExecuteReport={handleExecuteReport}
                    onClose={() => setShowInputModal(false)}
                    ReportID={selectedReportID}
                    ID={ID}
                />
            )}

            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-danger" onClick={() => setShowPdfModal(false)}>
                                        <i className="icofont-close" aria-hidden="true"> Close</i>
                                    </button>


                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ReportView;
